<div class="container">
  <mc-scheduling-form></mc-scheduling-form>
</div>
